import type { RequestsState } from '../reducers/requests';

export const requestsSelector = (state: GlobalState) => state.requests as RequestsState;
